import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-[25px] mb-[25px] min-h-[calc(100vh-200px)]" }
const _hoisted_2 = { class: "lg:col-span-2" }
const _hoisted_3 = { class: "lg:col-span-1 flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_PropertyDetails = _resolveComponent("PropertyDetails")!
  const _component_Owner = _resolveComponent("Owner")!
  const _component_PropertyNotes = _resolveComponent("PropertyNotes")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Property List",
      subTitle: "Real Estate"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_PropertyDetails)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Owner),
        _createVNode(_component_PropertyNotes, { class: "mt-[25px] flex-grow" })
      ])
    ])
  ], 64))
}